import { createSlice } from '@reduxjs/toolkit';
import { createFilterInitialState, filterReducers, FilterState } from 'common/utils/sliceUtils/filterSliceUtils';

type StateWithRoleUserGroup = { roleUserGroup: FilterState };

const roleUserGroupSlice = createSlice({
    name: 'roleUserGroup',
    initialState: createFilterInitialState(),
    reducers: () => ({
        ...filterReducers,
    })
});

// eslint-disable-next-line no-restricted-syntax
export default roleUserGroupSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters } = roleUserGroupSlice.actions;
export const selectFilters = (state: StateWithRoleUserGroup) => state.roleUserGroup.filters;
